import { DataManager, JsonAdaptor, Query } from '@syncfusion/ej2-data';
export class EnumFilterAdaptor extends JsonAdaptor {
  constructor() {
    super();
  }

  public getModuleName(): string {
    return 'EnumFilterAdaptor';
  }

  public override processQuery(dataManager: DataManager, query: Query): Object {
    var res = dataManager.dataSource.json.slice(0);
    var result = super.processQuery(dataManager, query) as any;
    if (result.aggregates != null) {
      result.result = res;
      result.count = res.length;
      return result;
    }
    return res;
  }
}
